import { render, staticRenderFns } from "./MockUp.vue?vue&type=template&id=5ecada08&"
import script from "./MockUp.vue?vue&type=script&lang=js&"
export * from "./MockUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports